module.exports = __webpack_public_path__ + "images/home/masters/logo-2b151afd826a8ec7d394d15384dac059.png";